import { render } from "./TableDataLazy.vue?vue&type=template&id=b5692ba2"
import script from "./TableDataLazy.vue?vue&type=script&lang=js"
export * from "./TableDataLazy.vue?vue&type=script&lang=js"

import "./TableDataLazy.vue?vue&type=style&index=0&id=b5692ba2&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__